import { render } from "./config-list.vue?vue&type=template&id=7206ece9&ts=true"
import script from "./config-list.ts?vue&type=script&lang=ts"
export * from "./config-list.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__